import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-my-assignments',
  templateUrl: './my-assignments.component.html',
  styleUrls: ['./my-assignments.component.scss'],
})
export class MyAssignmentsComponent {

  loader:boolean = true;
  category;
  name;
  id;
  change: boolean = false;

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }
  
      ionViewWillEnter(){
        this.getCategory();
      }
      getCategory(){
        this.service.getOrgCategory().subscribe((res: any) => {
          this.category=res;
          this.category.map(res=>{
            Object.assign(res,{select:false})
    
          })
          this.loader = false;
          this.name=res.name;
        }, err => {
          this.loader = false;
          this.handler.err(err)
        })
      }
  
     
      routeId(){   
        if(this.auth.checkCapability('MNGUSR') || this.auth.checkCapability('MNGORG') ){
        this.router.navigate(['/vendor-request']);
        }else if (this.auth.checkCapability('SC')){
         this.router.navigate(['/requests']);
        } 
       }
  
        }
  